<div class="error">
  <span class="material-icons error-icon">error</span>
  Please specify
</div>

<ng-container *ngIf="isMulti; else singleSelect">
  <div class="container">
    <div
      *ngFor="let item of items"
      class="item hfc-checkbox-list-item"
      [class.readonly]="readonly"
      [class.checked]="isChecked(item)"
      (click)="!readonly && onClicked(item)"
    >
      <div class="item-content">
        <ng-container *ngTemplateOutlet="itemTemplate || defaultItemTemplate; context: { $implicit: item }">
        </ng-container>

        <div *ngIf="hintTemplate" class="label">
          <ng-container *ngTemplateOutlet="hintTemplate; context: { $implicit: item }"></ng-container>
        </div>
      </div>

      <i *ngIf="isChecked(item)" class="material-icons">check</i>
    </div>
  </div>
</ng-container>

<ng-template #singleSelect>
  <div class="flex-gap">
    <hf-custom-radio-button
      *ngFor="let item of items"
      [name]="groupName"
      [value]="item"
      [label]="map ? map.get(item) : (item | json)"
      [disabled]="readonly"
      [ngModel]="selectedItem"
      [outerLayer]="true"
      (ngModelChange)="onRadioSelected($event)"
    ></hf-custom-radio-button>
  </div>
</ng-template>

<ng-template #defaultItemTemplate let-item>{{ map ? map.get(item) : item }}</ng-template>
